import React from 'react';
import { Fade } from 'react-awesome-reveal';

import {
  WebformWrapper,
} from '../../../components';

const WebformParagraph = ({ entity }) => {
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;
  return (
    <Fade triggerOnce bottom distance="50px" duration={500} className="Paragraph">
      <div id={paragraphKey} className="Paragraph WebformParagraph">
        <WebformWrapper entity={entity} />
      </div>
    </Fade>
  );
};

export default WebformParagraph;
